import {
  ADD_SCHOR_HORIZONTAL,
  EDIT_SCHOR_HORIZONTAL,
  LIST_SCHOR_HORIZONTAL,
  VIEW_SCHOR_HORIZONTAL,
  DELETE_SCHOR_HORIZONTAL,
  ADD_SCHOR_HORIZONTAL_TEXT,
  EDIT_SCHOR_HORIZONTAL_TEXT,
  LIST_SCHOR_HORIZONTAL_TEXT,
  VIEW_SCHOR_HORIZONTAL_TEXT,
  DELETE_SCHOR_HORIZONTAL_TEXT,
  SCHOR_HORIZONTAL_SUCCESS,
  SCHOR_HORIZONTAL_ERROR,
} from "./actionTypes"

const initialState = {
  successMsg: null,
  error: null,
  editLoading:false
}

const schorHorizontal = (state = initialState, action) => {
  switch (action.type) {

    // add asiration question
    case ADD_SCHOR_HORIZONTAL:
      state = {
        ...state,
        // loading: true,
        successMsg: null,
        error: null,
        editLoading:true
      }
      break
    case SCHOR_HORIZONTAL_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading:false
      }
      break
    case SCHOR_HORIZONTAL_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false }
      break

    // edit asiration question
    case EDIT_SCHOR_HORIZONTAL:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list asiration question
    case LIST_SCHOR_HORIZONTAL:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view asiration question
    case VIEW_SCHOR_HORIZONTAL:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete asiration question
    case DELETE_SCHOR_HORIZONTAL:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // text
    // add asiration question
    case ADD_SCHOR_HORIZONTAL_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case SCHOR_HORIZONTAL_SUCCESS:
      state = {
        ...state,
        loading: false,
        editLoading:false,
        successMsg: action.payload,
      }
      break
    case SCHOR_HORIZONTAL_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false,editLoading:false }
      break

    // edit asiration question
    case EDIT_SCHOR_HORIZONTAL_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list asiration question
    case LIST_SCHOR_HORIZONTAL_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view asiration question
    case VIEW_SCHOR_HORIZONTAL_TEXT:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete asiration question
    case DELETE_SCHOR_HORIZONTAL_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default schorHorizontal
